/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// mantine
import { notifications } from '@mantine/notifications';
import { rem } from '@mantine/core';

// i18n
import i18n from 'i18next';

// icons
import { IconCheck, IconX } from '@tabler/icons-react';

// api
import { apiClient } from '@lib/api-client';

// types
import { TCertificate } from '@global-types/index';

// enums
import { QueueStatus } from '@config/constants/enum';

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */
export const getCertificate = async (
	id: string,
	nameOffset: string,
	nameBrand: string,
	contributionDate: string,
	idNotification: string
) => {
	try {
		const fetchCertificate = async (id: string) => {
			let response: TCertificate;

			const getStatus = (response: TCertificate) => {
				return response?.status || '';
			};

			const getCertificate = async () => {
				response = await apiClient.get(
					`/certificates/${id}`,
					{
						params: {
							populate: ['media'],
						},
					}
				);

				const status = getStatus(response);
				console.log(
					'DOWNLOAD CERTIF  status = >',
					status
				);
				if (status == QueueStatus.IN_PROGRESS) {
					setTimeout(async () => {
						await getCertificate();
					}, 2000);
				}
				if (status == QueueStatus.ERROR) {
					notifications.update({
						id: idNotification,
						loading: false,
						color: 'red',
						title: `${i18n.t(`global.error`)}`,
						message: `${i18n.t(
							`dashboard.error.downloadCertificate`
						)}`,
						icon: (
							<IconX
								style={{
									width: rem(18),
									height: rem(18),
								}}
							/>
						),
						autoClose: 2000,
					});
				} else {
					if (response.media) {
						fetch(response.media)
							.then((response) => response.blob())
							.then((blob) => {
								const url = window.URL.createObjectURL(
									new Blob([blob])
								);

								const link = document.createElement('a');

								link.href = url;

								link.download = `${nameBrand}_${nameOffset}_${contributionDate}.pdf`;

								document.body.appendChild(link);

								link.click();

								document.body.removeChild(link);

								window.URL.revokeObjectURL(url);

								notifications.update({
									id: idNotification,
									loading: false,
									color: 'success',
									title: `${i18n.t(
										`offsets.notifications.downloadComplete`
									)}`,
									message: `${i18n.t(
										`offsets.notifications.theCertificate`
									)} ${nameOffset} ${i18n.t(
										`offsets.notifications.isNowFullyDownloaded`
									)}`,
									icon: (
										<IconCheck
											style={{
												width: rem(18),
												height: rem(18),
											}}
										/>
									),
									autoClose: 7000,
								});
							})
							.catch((error) => {
								console.error(
									'Error fetching blob file :',
									error
								);
								notifications.update({
									id: idNotification,
									loading: false,
									color: 'error',
									title: i18n.t(`global.error`),
									message: i18n.t(`api.NOT_FOUND`),
									autoClose: 7000,
									icon: (
										<IconX
											style={{
												width: rem(18),
												height: rem(18),
											}}
										/>
									),
								});
							});
					}
				}
			};

			await getCertificate();
		};

		fetchCertificate(id);
	} catch (error) {
		console.error('error certificate[api] :', error);
		notifications.update({
			id: idNotification,
			loading: false,
			color: 'error',
			title: i18n.t(`global.error`),
			message: i18n.t(`api.NOT_FOUND`),
			autoClose: 7000,
			icon: (
				<IconX
					style={{ width: rem(18), height: rem(18) }}
				/>
			),
		});
	}
};
